export const TRANSFER_FUND_START = 'TRANSFER_FUND_START';
export const TRANSFER_FUND_SUCCESS = 'TRANSFER_FUND_SUCCESS';
export const TRANSFER_FUND_ERROR = 'TRANSFER_FUND_ERROR';
export const TRANSFER_FUND_END = 'TRANSFER_CONFIRMATION_END';
export const CLEAR_TRANSFER_FUND_STORE = 'CLEAR_TRANSFER_FUND_STORE';
